/*
Monotype Foundry Platform API
Version 1.0.0

Definition: CreateNewFamilyRequest

Properties:
  familyName: string (required)
*/

var CreateNewFamilyRequest = (function () {
  function validateCreateNewFamilyRequest (arg) {
    // Validate familyName
    if (!arg.familyName) {
      throw new Error('CreateNewFamilyRequest.familyName: Missing property')
    }
    if (arg.familyName && !(typeof arg.familyName === 'string')) {
      throw new Error('CreateNewFamilyRequest.familyName: Wrong type: Got \'' + (typeof arg.familyName) + '\', but expected: \'string\'')
    }
  }
  function buildCreateNewFamilyRequest (arg) {
    var CreateNewFamilyRequest = arg
    // Complete familyName
    // Expected Type: string
    CreateNewFamilyRequest.familyName = CreateNewFamilyRequest.familyName || ''
    return CreateNewFamilyRequest
  }
  return {
    validate: validateCreateNewFamilyRequest,
    build: buildCreateNewFamilyRequest
  }
})()

module.exports = CreateNewFamilyRequest
